{
  "action": {
    "addPrice": "Ajouter un nouveau prix",
    "stopMerge": "Arrêter la fusion"
  },
  "backButtonTitle": {
    "backButtonLabel": {
      "backToLocations": "Retour à la liste des établissements"
    },
    "title": {
      "addClosedDate": "Ajouter une date de fermeture",
      "addEmployee": "Ajouter un employé",
      "addLocation": "Ajouter un établissement",
      "addMachine": "Ajouter une ressource matérielle",
      "addRegion": "Ajouter une région",
      "addService": "Ajouter une prestation",
      "addTimetable": "Ajouter un horaire",
      "addWorkplace": "Ajouter un espace de travail",
      "edit": "Editer",
      "newTimetable": "Nouvel horaire récurent",
      "newTimetableException": "Nouvel horaire exceptionnel"
    }
  },
  "book": {
    "bookCard": {
      "button": {
        "book": "Réserver en ligne",
        "discover": "Découvrir"
      }
    },
    "text": "{weeezy} compte déjà plusieurs prestataires dont les prestations peuvent vous intéresser !",
    "title": "Réserver maintenant"
  },
  "booking": {
    "AdditionalServices": "Prestations supplémentaires",
    "addAnEvent": {
      "customerAppointment": "Rendez-vous client",
      "event": "Événement privé",
      "title": "Ajouter un événement",
      "type": "Type d'évènement"
    },
    "at": "à",
    "closing": {
      "careful": "Attention",
      "expressTitle": "Clôture sans réservation",
      "fidelityVoucher": "Bon de fidélité",
      "giftAlreadyUsed": "Bon déjà utilisé dans cette clôture",
      "giftCards": "Bons cadeaux",
      "giftUuidTooLong": "Identifiant trop long, 8 caractères",
      "negativePaymentWarning": "Il y a des paiements négatifs, souhaitez-vous les vérifier ?",
      "overPaid": "Payé en trop",
      "payments": "Paiements",
      "price": "Prix",
      "show": "Venu",
      "start": "Début",
      "title": "Clôture",
      "titleModify": "Modification de la clôture",
      "total": "Total"
    },
    "completeProfileHint": "Pour confirmer votre réservation, ajoutez votre {fields}.",
    "completeProfileTitle": "Complétez votre profil",
    "history": "Historique d'une prestation",
    "outOfSchedule": "hors calendrier",
    "sendConfirmationEmail": "Envoyer l'e-mail de confirmation",
    "stepComment": "Commentaire",
    "stepCustomer": "Client",
    "stepDate": "Date",
    "stepMyAccount": "Mon compte",
    "title": "Nouvelle réservation",
    "titleAdd": "Nouveau rendez-vous",
    "titleEdit": "Modifier le rendez-vous"
  },
  "bookingConfirmation": {
    "doneBy": "Effectué par",
    "from": "de",
    "title": "Réservation enregistrée | Réservations enregistrées",
    "to": "à"
  },
  "bookingSelectModal": {
    "title": "Sélectionnez votre préférence"
  },
  "bookingStatus": {
    "canceled": "Annulé",
    "executed": "Effectué",
    "noShow": "Non venu",
    "open": "Ouvert"
  },
  "bookingStepChange": {
    "bookingVerifyError": "Le RDV sélectionné n'est malheureusement plus disponible. Il a été réservé il y a quelques instants. | Un des RDVs sélectionnés n'est malheureusement plus disponible. Il a été réservé il y a quelques instants."
  },
  "bookingStepDate": {
    "choseDate": "Sélectionnez une date",
    "choseTime": "Sélectionnez une heure",
    "subtitle": "Réservation n°{number}",
    "tip": "Nous allons effectuer {number} réservations différentes, car les soins que vous avez sélectionnés ne peuvent pas être effectués par un(e) seul(e) employé(e).",
    "title": "Date et heure"
  },
  "bookingStepDateTimeSlots": {
    "none": "Aucun créneau horaire n'est disponible"
  },
  "bookingStepPlace": {
    "indication": "Vous pouvez sélectionner plusieurs soins.",
    "location": "Etablissement",
    "services": "Prestations"
  },
  "bookingStepPlaceServices": {
    "eraseFilter": "Effacer les filtres",
    "search": "Nom ou numéro du soin"
  },
  "bookingStepVerification": {
    "comment": "Commentaire",
    "doneBy": "Effectué par",
    "legalConditionsIndications": "Veuillez lire et accepter les conditions ci-dessous.",
    "legalConditionsTitle": "Conditions générales",
    "title": "Vérification"
  },
  "bookingSummary": {
    "from": "de",
    "none": "Aucune sélection",
    "remove": "Enlever",
    "title": "Résumé",
    "to": "à"
  },
  "bookingView": {
    "cancelMessage": "Message en"
  },
  "button": {
    "about": "Présentation",
    "add": "Ajouter",
    "addArticle": "Ajouter article",
    "addService": "Ajouter une prestation",
    "addTimeRange": "Ajouter un bloc de travail",
    "back": "Retour",
    "bookAppointment": "Prendre RDV",
    "cancel": "Annuler",
    "cancelBooking": "Annuler la réservation",
    "cash": "Comptant",
    "cc": "Carte de débit/crédit",
    "close": "Fermer",
    "closeBooking": "Clôturer",
    "closeFrom": "Planifier la fermeture",
    "closeNoShow": "Non présenté",
    "complete": "Compléter",
    "confirm": "Confirmer",
    "confirmBooking": "Confirmer la réservation",
    "confirmTimetableAdd": "Confirmer l'ajout de l’horaire",
    "confirmTimetableCancel": "Confirmer la suppression de l’horaire",
    "contact": "Contact",
    "copied": "Noté",
    "createNewEmployee": "Créer un nouvel employé",
    "createNewEvent": "Ajouter un événement",
    "createNewLocation": "Créer un nouvel établissement",
    "createNewRegion": "Créer une nouvelle région",
    "createNewResource": "Créer une nouvelle ressource",
    "createNewService": "Créer une nouvelle prestation",
    "createNewWorkplace": "Créer un nouvel espace de travail",
    "delete": "Supprimer",
    "done": "Fait",
    "download": "Télécharger",
    "duplicate": "Dupliquer",
    "edit": "Modifier",
    "end": "Terminer",
    "endProcess": "Retour au compte",
    "getStarted": "C'est parti !",
    "goTo": "Aller à",
    "hideDetails": "Cacher détails",
    "ignore": "Ignorer",
    "later": "Plus tard",
    "leave": "Quitter",
    "login": "Se connecter",
    "merge": "Fusionner",
    "modify": "Modifier",
    "modifyClose": "Modifier la clôture",
    "more": "Plus d'info",
    "new": "Nouveau",
    "newBooking": "Rendez-vous client",
    "newBreak": "Pause",
    "newEvent": "Privé",
    "newTransport": "Déplacement",
    "next": "Suivant",
    "open": "Ouvrir",
    "pay": "Payer",
    "plan": "Planifier",
    "postfinance": "Postcard",
    "previous": "Précédent",
    "refresh": "Actualiser",
    "reset": "Réinitialiser",
    "retry": "Réessayer",
    "save": "Enregistrer",
    "send": "Envoyer",
    "showDetails": "Voir détails",
    "today": "Aujourd'hui",
    "translate": "Traduire",
    "verify": "Vérifier",
    "view": "Voir"
  },
  "calendar": {
    "actualBloc": "bloc actuel",
    "capacityThreshold": "Le {actualBloc} doit être rempli {capacityThreshold} pour que le prochain bloc s'ouvre.",
    "eventResourcesFailed": "Les lieux et espaces de travail n'ont pas pu être chargés : les rendez-vous s'affichent sans leur couleur.",
    "group": "Groupe",
    "individual": "Individuel",
    "sync": {
      "addToIOS": "Ajouter à mon iPhone / iPad",
      "addToMac": "Ajouter à mon Mac",
      "footer": "Depuis votre appareil ou votre logiciel d'agenda, vous devez vous abonner au flux iCal en ajoutant un nouveau calendrier \"A partir d'une URL\", parfois également appelé \"S'abonner à un calendrier\".",
      "googleCalendarGuide": "Guide Google Agenda",
      "googleCalendarGuideInfo": "Veuillez noter que les modifications sur Weeezy peuvent prendre jusqu'à 8 heures pour être mises à jour dans votre calendrier Google. Si vous désirez une synchronisation plus fréquente, nous recommandons d'utiliser Outlook pour Windows ou le calendrier Apple sur Mac OS et iOS.",
      "googleCalendarGuideStep1": "Depuis votre navigateur internet, dans la barre latérale de Google Agenda, cliquez sur + au niveau du menu \"Autres agendas\"",
      "googleCalendarGuideStep2": "Sélectionnez l'option \"À partir de l'URL\"",
      "googleCalendarGuideStep3": "Collez l'adresse iCal dans le champ URL de l'agenda",
      "howItWorks": "Comment ça marche ?",
      "ical": "Flux iCal",
      "outlookGuide": "Guide Outlook (Ajouter des calendriers Internet)",
      "paragraph1": "Synchronisez votre calendrier Weeezy avec votre calendrier personnel.",
      "quickAccess": "Accès rapide",
      "title": "Sync calendrier"
    }
  },
  "cardStatus": {
    "active": "Active",
    "expired": "Echue",
    "inProgress": "Bientôt disponible",
    "partiallyUsed": "Partiellement utilisée",
    "used": "Utilisée"
  },
  "category": {
    "automatic": "Automatique",
    "manual": "Manuelle"
  },
  "checkEventsConflictsModal": {
    "addClosedData": {
      "title": "Ajouter un jour de fermeture"
    },
    "addClosedForm": {
      "title": "Planifier la fermeture"
    },
    "addTimetableException": {
      "title": "Ajouter un horaire exceptionnel"
    },
    "cancelMessage": "Message d'annulation",
    "cancelMessageHelp": "Veuillez expliquer la raison de cette annulation",
    "conflicts": "Il y a des conflits avec les réservations existantes. Veuillez les régler avant de les soumettre.",
    "customers": {
      "title": "Supprimer client"
    },
    "deleteAllEvents": "Annuler tous les événements",
    "editClosedDate": {
      "title": "Modifier un jour de fermeture"
    },
    "inputErrors": "Vous avez des erreurs dans les données saisies, veuillez les corriger et réessayer.",
    "noConflicts": "Il n'y a pas de conflits avec les événements existants. Vous pouvez terminer l'action en cliquant sur le bouton {buttonTitle}.",
    "services": {
      "title": "Modifier une prestation"
    },
    "timetableExceptions": {
      "title": "Supprimer un horaire exceptionnel"
    },
    "timetables": {
      "title": "Supprimer un horaire"
    },
    "workplaces": {
      "delete": {
        "title": "Supprimer espace de travail"
      },
      "modify": {
        "title": "Modifier espace de travail"
      }
    }
  },
  "closedBookings": {
    "none": "Aucun rendez-vous clôturé",
    "title": "Rendez-vous clôturés"
  },
  "closedDateForm": {
    "location": {
      "label": "Etablissements"
    }
  },
  "closedDates": {
    "title": "Jours de fermeture"
  },
  "columnHeader": {
    "amount": "Montant",
    "balance": "Solde",
    "customer": "Client",
    "date": "Date",
    "employee": "Employé",
    "faceValue": "Valeur nominale",
    "method": "Mode",
    "no": "N°",
    "paid": "Payé",
    "payment": "Paiement",
    "price": "Prix",
    "quantity": "Quantité",
    "services": "Soins",
    "status": "Statut",
    "total": "Total",
    "uuid": "Code",
    "validUntil": "Valable jusqu'au",
    "wording": "Libellé"
  },
  "configError": {
    "closedDateLocations": "Vous devez assigner au moins un établissement à cette date de fermeture pour qu'elle soit utilisée.",
    "employeeServices": "Vous devez assigner au minimum une prestation à cet employé pour qu'il puisse honorer des rendez-vous.",
    "employeeServicesWorkplaces": "Cette prestation ne peut pas être réservée, car elle n'a aucun espace de travail en commun avec cet employé : {services}. | Ces prestations ne peuvent pas être réservées, car elles n'ont aucun espace de travail en commun avec cet employé : {services}.",
    "employeeWorkplaces": "Vous devez assigner au minimum un espace de travail à cet employé pour qu'il puisse honorer des rendez-vous.",
    "locationRegion": "Vous devez assigner une région à cet établissement pour qu'il puisse être réservé.",
    "machineServices": "Cette ressource est associée à aucune prestation.",
    "machineWorkplaces": "Cette ressource est associée à aucun espace de travail.",
    "regionLocations": "Vous devez assigner au moins un établissement à cette région pour qu'elle puisse être utilisée.",
    "serviceEmployees": "Vous devez assigner au minimum un employé à cette prestation pour qu'elle puisse être réservée.",
    "serviceWorkplaces": "Vous devez assigner au minimum un espace de travail à cette prestation pour qu'elle puisse être réservée.",
    "title": "Problème de configuration",
    "workplaceEmployees": "Vous devez assigner au minimum un employé à cet espace de travail pour qu'il puisse être réservé.",
    "workplaceServices": "Vous devez assigner au minimum une prestation à cet espace de travail pour qu'il puisse être réservé."
  },
  "confirmModal": {
    "cancelBooking": {
      "message": "Veuillez confirmer l'annulation de la réservation du {startDate} à {startTime} à l'aide du bouton \"Annuler la réservation\" ci-dessous."
    },
    "deleteBooking": "Veuillez confirmer l'annulation du RDV à l'aide du bouton \"Annuler RDV\".",
    "deleteClosedBooking": {
      "message": "Veuillez confirmer la suppression de la réservation du {startDate} à {startTime} à l'aide du bouton \"Supprimer la réservation\" ci-dessous."
    },
    "deleteClosedDate": {
      "message": "Veuillez confirmer la suppression du jour de fermeture le {date} {summary} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteComment": {
      "message": "Veuillez confirmer la suppression du commentaire de {commentAuthor} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteEvent": "Veuillez confirmer la suppression de l'événement à l'aide du bouton \"Supprimer\".",
    "deleteInvoice": {
      "message": "Veuillez confirmer la suppression de la facture n°{number} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteLocation": {
      "message": "Veuillez confirmer la suppression de l'établissement {locationName} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteMachine": {
      "message": "Veuillez confirmer la suppression de la ressource {machine} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteMachineModel": {
      "message": "Veuillez confirmer la suppression du modèle {machineModel} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteRegion": {
      "message": "Veuillez confirmer la suppression de la région {regionName} à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "deleteService": {
      "message": "Si des rendez-vous ont été pris avec cet employé et ces prestations, ils seront gardés.<br />Veuillez confirmer la suppression de la prestation <b>{serviceName}</b> à l'aide du bouton \"Supprimer\" ci-dessous."
    },
    "locationReopen": {
      "message": "Ouvrir à nouveau {location}"
    },
    "revokingSlack": {
      "message": "Voulez-vous réellement supprimer l'intégration Slack pour votre équipe {team} ?"
    },
    "title": "Confirmation"
  },
  "conflictEventAction": {
    "cancelEvent": "Annuler l'évènement",
    "checkDetails": "Voir les détails",
    "createTimetableException": "Conserver l'horaire existant pour cette date"
  },
  "customerComment": {
    "add": "Ajouter un commentaire",
    "edit": "Modifier un commentaire",
    "editedBy": "Modifié par {name} le {date}",
    "empty": "Aucun commentaire",
    "title": "Notes internes"
  },
  "customerForm": {
    "addTitle": "Ajouter un client",
    "editTitle": "Modifier un client",
    "passwordPlaceholder": "Laisser vide si inchangé"
  },
  "customerView": {
    "mr": "Monsieur",
    "mrs": "Madame",
    "pageTitle": "Compte client",
    "private": "Privé",
    "professional": "Pro",
    "stats": {
      "cancelled": "Annulé | Annulé | Annulés",
      "noShow": "Non venu",
      "unpaid": "non payé | non payé |  non payés"
    },
    "title": "Fiche client"
  },
  "customersMerge": {
    "confirm": "Confirmer la fusion",
    "conflicts": "Nous avons constaté que certains champs sont en conflit, merci de sélectionner la valeur correcte. Vous pourrez toujours éditer le compte client après la fusion si aucune valeur ne correspond.",
    "loadFailed": "Impossible de charger les clients à fusionner.",
    "mergeFailed": "La fusion des clients a échoué.",
    "noConflict": "Aucun autre conflit à signaler.",
    "title": "Fusionner les clients",
    "userAccountKept": "Le mot de passe et nom d'utilisateur associés à ce compte seront gardés.",
    "warning": "Cette action est définitive et irréversible. Merci de confirmer la fusion en cliquant sur le bouton \"Fusionner\"."
  },
  "deviceSessions": {
    "changeTitle": "Modifier votre PIN",
    "chooserHelp": "Des employés sont connectés sur cet appareil. Choisissez le vôtre et saisissez votre PIN.",
    "chooserTitle": "Reprendre une session",
    "expired": "La session de cet employé a expiré sur cet appareil, il doit se reconnecter avec son mot de passe.",
    "logMeIn": "Me connecter",
    "logoutDevice": "Déconnecter tout le monde",
    "logoutDeviceConfirm": "Toutes les sessions garées sur cet appareil ({count}) seront fermées. Chaque employé devra se reconnecter avec son mot de passe.",
    "pin": "PIN",
    "pinHint": "Six chiffres, sans suite ni répétition.",
    "pinOf": "PIN de {name}",
    "saved": "Votre PIN est enregistré.",
    "setupHelp": "Cet appareil est partagé avec vos collègues. Votre PIN vous rend votre session sans retaper votre mot de passe à chaque fois.",
    "setupTitle": "Définissez votre PIN",
    "switch": "Changer d'employé",
    "title": "Changer d'employé"
  },
  "emailValidation": {
    "loaderLabel": "Vérification"
  },
  "employeeForm": {
    "basics": {
      "title": "Données utilisateur"
    },
    "invitationEmail": {
      "help": "Facultatif. L'employé reçoit un lien pour créer son compte ou lier celui qu'il a déjà.",
      "label": "E-mail pour l'invitation"
    },
    "nonPreferredServices": {
      "label": "Prestations habilitées non prioritaires",
      "labelTooltip": "Lors de la prise de RDV, un employé sera NON PRIORITAIRE et sera proposé pour effectuer ces soins uniquement si aucun employé prioritaire n'est disponible."
    },
    "nonPreferredWorkplaces": {
      "label": "Espaces de travail non prioritaires",
      "labelTooltip": "La salle ne pourra être occupée par cet employé que si les employés prioritaires ne sont pas disponibles."
    },
    "preferredServices": {
      "label": "Prestations habilitées prioritaires",
      "labelTooltip": "Lors de la prise de RDV, l'employé sera PRIORITAIRE et sera toujours proposé pour effectuer ces soins s'il est disponible."
    },
    "preferredWorkplaces": {
      "label": "Espaces de travail prioritaires",
      "labelTooltip": "La salle ne pourra être occupé que par cet employé s'il est disponible."
    },
    "removedServicesWarning": "Si des RDV futures avec cet employé utilisant ces prestations, elles seront gardés. Prestations :",
    "removedWorkplacesWarning": "Si des RDV futures avec cet employé utilisant ces espaces de travail, elles seront gardés. Espaces de travail :",
    "requiredLocationsRemovedMessage": "L'employé a des horaires définis avec un établissement manquant. Veuillez vous assurer que ces établissements sont associés à l’employé ou modifiez les horaires au préalable.",
    "timetableExceptionLocations": "L'horaire spéciaux du {date} utilise les établissements suivants :",
    "timetableLocations": "L'horaire dès le {validFrom} utilise les établissements suivants :"
  },
  "emptyDataset": {
    "closedDate": "Aucun jour de fermeture prévu",
    "default": "Aucun résultat",
    "location": "Aucun établissement pour l'instant",
    "planning": "Votre planning est vide",
    "region": "Aucune région",
    "service": "Aucune prestation",
    "workplaces": "Aucun espace de travail"
  },
  "error": {
    "imageLoadFailed": "Impossible de charger l'image",
    "unexpectedApiResponse": "Réponse inattendue de l'API"
  },
  "fetchFailure": {
    "customerView": "Une erreur est survenue lors du chargement du compte client."
  },
  "fidelityVouchers": {
    "alreadyAccumualted": "Pas de montant accumulé. | CHF 1 accumulé. | CHF {n} accumulés.",
    "expired": "Expiré",
    "nextVoucher": "Bon reçu au dernier soin. | Prochain bon à la prochaine réservation. | Prochain bon dans {n} réservations.",
    "none": "Aucun bon de fidélité",
    "title": "Bons de fidélité",
    "use": "Utiliser bon fidélité",
    "valid": "Valable"
  },
  "filePond": {
    "acceptedFormats": "Formats acceptés",
    "dimensionRange": "Dimensions",
    "fileCount": "Un seul fichier | Maximum {count} fichiers",
    "imageValidateSizeLabelExpectedMaxSize": "Taille maximale : ",
    "imageValidateSizeLabelExpectedMinSize": "Taille minimale : ",
    "imageValidateSizeLabelFormatError": "Le format de l'image n'est pas valide",
    "imageValidateSizeLabelImageResolutionTooHigh": "La résolution est trop élevée",
    "imageValidateSizeLabelImageResolutionTooLow": "La résolution est trop basse",
    "imageValidateSizeLabelImageSizeTooBig": "L'image est trop grande",
    "imageValidateSizeLabelImageSizeTooSmall": "L'image est trop petite",
    "labelButtonAbortItemLoad": "Abandonner",
    "labelButtonAbortItemProcessing": "Annuler",
    "labelButtonProcessItem": "Envoyer",
    "labelButtonRemoveItem": "Supprimer",
    "labelButtonRetryItemLoad": "Réessayer",
    "labelButtonRetryItemProcessing": "Réessayer",
    "labelButtonUndoItemProcessing": "Annuler",
    "labelDecimalSeparator": ",",
    "labelFileLoadError": "Erreur lors du chargement",
    "labelFileLoading": "Chargement",
    "labelFileProcessing": "Envoi en cours",
    "labelFileProcessingAborted": "Envoi annulé",
    "labelFileProcessingComplete": "Envoi terminé",
    "labelFileProcessingError": "Erreur lors de l'envoi",
    "labelFileProcessingRevertError": "Erreur lors de l'annulation",
    "labelFileRemoveError": "Erreur lors de la suppression",
    "labelFileSizeNotAvailable": "Taille non disponible",
    "labelFileWaitingForSize": "En attente de la taille",
    "labelIdle": "Glissez-déposez vos fichiers ou <span class=\"filepond--label-action\">Parcourir</span>",
    "labelInvalidField": "Le champ contient des fichiers non valides",
    "labelTapToCancel": "appuyer pour annuler",
    "labelTapToRetry": "appuyer pour réessayer",
    "labelTapToUndo": "appuyer pour annuler",
    "labelThousandsSeparator": " ",
    "maxDimension": "Dimension maximale",
    "maxSize": "Taille maximum",
    "minDimension": "Dimension minimale",
    "perFile": "par fichier"
  },
  "forgotPassword": {
    "title": "Réinitialiser votre mot de passe"
  },
  "formInput": {
    "errorOccurred": "Une erreur s'est produite",
    "optional": "Optionnel",
    "phoneHelpText": "Format international, ex : +41 79 123 45 67",
    "selectFile": "Sélectionnez le fichier"
  },
  "free": "Gratuit",
  "guard": {
    "insufficientPermissions": "Votre niveau d'accès est insuffisant pour accéder à cette page.",
    "notLoggedIn": "Vous devez vous connecter pour accéder à cette page."
  },
  "help": {
    "title": "Aide"
  },
  "helpBox": {
    "pricesMayVary": "Les prix peuvent varier en fonction de la date choisie à l'étape suivante."
  },
  "helpText": {
    "actualFreeTimeSlotFirstBooking": "A tout moment, votre agenda est vérouillé pour les clients pendant {amount} minutes",
    "associations": "Chaque prestation peut être faite par une sélection de collaborateur et de place de travail. Vous pouvez définir cela ici.",
    "availableBookingsInterval": "[Ex: 15] Le système proposera un rendez-vous toutes les 15 minutes.",
    "bookingSlotsPropositionInterval": "Les rendez-vous commencent aux [Ex : 5] 5', 10', 15, ... et aux [Ex : 15] 15', 30', 45', ...",
    "cancellationNotice": "Les clients ne pourront annuler que les rendez-vous prévu dans plus de {amount} heures",
    "category": "Si votre catégorie de prestation n'apparaît pas, veuillez contacter notre support technique",
    "clientExitDuration": "Après chaque rendez-vous, le système vous donne {amount} minutes pour ranger et encaisser votre client",
    "closedFrom": "Un établissement ouvert doit avoir ce champ vide",
    "comment": "Ce commentaire est visible par le client",
    "companyName": "Nom officiel de votre entreprise tel qu'enregistré légalement",
    "emailReminderOffset": "Un e-mail de rappel sera envoyé {amount} heures avant le rendez-vous",
    "favoriteEmployee": "Employé prioritaire",
    "favoriteEmployeeOnly": "En cochant cette case, seules les propositions avec {firstName} apparaîtront. Sinon, nous proposerons d'autres employés quand {firstName} n'est pas disponible.",
    "fixedDuration": "La durée de la prestation sera toujours celle de base, sans adaptation au client.",
    "locationName": "Usage public",
    "locationShortName": "Usage privé",
    "numberOfVisitForVoucher": "Après {amount} réservations payées, le client reçoit un bon de fidélité",
    "pictureMinimumSize": "Image de 200x200 pixels minimum",
    "pointsPerChfConversion": "Le client reçoit CHF 1 de fidélité pour CHF {amount} dépensé sur ses réservations",
    "price": "Vous ne pouvez pas modifier le prix actuel. Pour changer le prix, ajoutez un nouveau prix valable à partir d'une date ultérieure.",
    "privateComment": "Cette note n'est pas visible par le client",
    "publicName": "Ce nom sera celui affiché sur le site",
    "serviceDuration": "La durée des prestation est adapté au client. La durée de base est utilisée pour les nouveaux clients ou lorsque vous cochez \"Durée fixe\". ",
    "slug": "Texte utilisé dans l'url",
    "smsReminderOffset": "Un sms de rappel sera envoyé {amount} heures avant le rendez-vous",
    "uidNumber": "Suisse seulement",
    "uniqueName": "Le nom doit être unique",
    "voucher": "Identifiant unique du bon composé de 8 lettres"
  },
  "home": {
    "button": {
      "contactUs": "Contactez-nous",
      "demo": "Planifier une démo",
      "discoverOurPrices": "consulter les tarifs",
      "freeTrial": "Essai gratuit",
      "subscribe": "S'inscrire",
      "takeALook": "En savoir plus"
    },
    "homeAppointment": {
      "resources": "Une fois votre compte configuré vous n'aurez plus à vous soucier que d'offrir les meilleures prestations à vos clients.",
      "setUp": "Créez votre compte {weeezy} et vos clients pourront réserver vos prestations en ligne.",
      "title": "Permettez à vos clients de réserver vos prestations en ligne"
    },
    "homeBasicAdvanced": {
      "complex": {
        "text": "Vos employés, répartis sur plusieurs sites, font des métiers différents et se partagent leur place de travail et les appareils.",
        "title": "Complexe"
      },
      "easy": {
        "text": "Tous vos employés travaillent sur un seul site et font tous le même métier à leur propre place de travail.",
        "title": "Simple"
      },
      "paragraphe": "Avec {weeezy} vous pouvez gérer des situations très simples ou très compliquées sans problème !",
      "title": "Un vrai couteau suisse"
    },
    "homeFeatures": {
      "homeCards": {
        "customersRelationship": {
          "text": "Suivez vos clients, leurs rendez-vous et leurs paiements en un clin d'œil.",
          "title": "Suivi client"
        },
        "employeesSchedules": {
          "text": "Planifiez vos employés plusieurs mois à l'avance avec notre outil avancé.",
          "title": "Horaires des employés"
        },
        "exhaustiveCalendar": {
          "text": "Voir son planning, sa semaine ou encore son équipe clairement.",
          "title": "Calendrier complet"
        },
        "servicesManagement": {
          "text": "Créez vos prestations et gérez leurs liens avec vos ressources pour des rendez-vous optimaux.",
          "title": "Gestion des prestations"
        }
      },
      "text": "Avec seulement quelques réglages {weeezy} permet rapidement de prendre des rendez-vous en ligne tant à vos clients qu'à vos employés.",
      "title": "Configurer {weeezy} est très simple"
    },
    "homeOtherFeatures": {
      "homeCards": {
        "giftVouchers": {
          "text": "Emettre et payer avec des bons cadeaux n'a jamais été aussi simple.",
          "title": "Bons cadeaux"
        },
        "loyaltyManagement": {
          "text": "Récompensez vos clients avec notre programme de fidélité flexible.",
          "title": "Programme de fidélité"
        },
        "multipleLocations": {
          "text": "Planifiez vos employés, ressources et prestations sur vos différents sites.",
          "title": "Entreprise multisite"
        },
        "priorityManagement": {
          "text": "Décidez si un employé doit être prioritaire sur une prestation ou une place de travail.",
          "title": "Employés prioritaires"
        },
        "reactiveSchedule": {
          "text": "Soyez là quand vos clients ont besoin de vous, sans perdre le contrôle.",
          "title": "Horaires réactifs"
        },
        "sharedResources": {
          "text": "Assurez-vous d'avoir toujours les ressources dont vous avez besoin pour vos prestations.",
          "title": "Ressources partagées"
        }
      },
      "paragraphe": "Avec votre compte {weeezy} vous avez accès à tout, même aux outils les plus avancés !",
      "title": "Outils avancés"
    },
    "homePrice": {
      "priceCard": {
        "3Months": "3 mois d'essai gratuit",
        "EasyToUse": "Facile à utiliser",
        "allFeatures": "Accès à tous les outils",
        "billedAnnualy": "Licence annuelle",
        "emailAndSlack": "E-mail et Slack inclus",
        "muchMore": "Et bien plus encore...",
        "oneSolution": "Une formule pour tous les besoins",
        "per": "par employé, par mois",
        "smsCost": "0.15 par sms",
        "smsReminder": "Rappels SMS",
        "title": "Notre prix"
      }
    },
    "homePrices": {
      "demoFirst": {
        "text": "Vous souhaitez que nous vous fassions la démonstration de notre incroyable outil ? Aucun souci, nous organiserons un rendez-vous virtuel pour vous le montrer !",
        "title": "Une démo ?"
      },
      "freeTrial": {
        "text": "Créez votre compte de prestataire et essayez sans engagement pour une période de 3 mois. Aucune carte de crédit n'est nécessaire.",
        "title": "Essai gratuit"
      }
    },
    "homeTimeMoney": {
      "missCustomer": {
        "answering": "Répondre à tous vos clients quelle que soit la taille de votre entreprise est une tâche herculéenne.",
        "title": "Répondez à tous vos clients",
        "withWeeezy": "Avec {weeezy}, vos clients peuvent prendre rendez-vous quand ils le souhaitent que vous soyez disponible ou non."
      },
      "saveTime": {
        "text": "Fini de perdre du temps à planifier les rendez-vous client, concentrez-vous sur vos prestations et votre expertise.",
        "title": "Economisez du temps et de l'argent"
      }
    },
    "homeTitle": {
      "text": "Une application cloud pour vous aider à gérer vos prestations, agendas et permettre à vos clients de réserver en ligne",
      "title": "Tout-en-1 pour les prestations sur rendez-vous"
    }
  },
  "invoiceAddModal": {
    "editInfo": "Pour éditer une facture existante, il faut la supprimer et en refaire une nouvelle.",
    "title": "Nouvelle facture"
  },
  "invoiceStatus": {
    "open": "Impayée",
    "overpaid": "Trop payée",
    "paid": "Payée",
    "partial": "Payée partiellement"
  },
  "invoiceViewModal": {
    "title": "Facture n°"
  },
  "invoices": {
    "none": "Aucune facture",
    "title": "Facture|Factures"
  },
  "label": {
    "actualFreeTimeSlotFirstBooking": "Durée de verrouillage de l'agenda",
    "actualPrice": "Prix actuel",
    "address": "Adresse",
    "addressComplement": "Complément d'adresse",
    "all": "Tous",
    "allFeminine": "Toutes",
    "allPaymentMethod": "Tous les moyens de paiement",
    "allowedServices": "Prestations autorisées",
    "amount": "Montant",
    "append": {
      "boxes": "cases",
      "hours": "heures",
      "minutes": "minutes",
      "mn": "min",
      "month": "mois",
      "points": "points",
      "visits": "réservations"
    },
    "availableBookingsInterval": "Fréquence de proposition des rendez-vous",
    "balance": "Solde à payer",
    "baseDuration": "Durée de base",
    "birthdate": "Date de naissance",
    "bookingSlotsPropositionInterval": "Précision du rendez-vous pour les clients",
    "break": "Temps de pause",
    "calendarColor": "Couleur du calendrier",
    "canCreateBookingsOutOfTimetables": "Peut créer des réservations en dehors des horaires",
    "canSetOwnTimetables": "Peut définir ses propres horaires",
    "cancellationNotice": "Délai d'annulation",
    "capacityThreshold": "Taux de remplissage avant l'ouverture d'un autre bloc",
    "card": "Carte de crédit et débit",
    "cash": "Comptant",
    "category": "Catégorie",
    "changeValidFrom": "Changement valable dès le",
    "city": "Localité",
    "clientExitDuration": "Durée de rangement",
    "comment": "Commentaire",
    "companyName": "Nom de l'entreprise",
    "country": "Pays",
    "created": "Créé le",
    "customer": "Client | Clients",
    "customerName": "Nom du client",
    "date": "Date",
    "day": "Jour",
    "description": "Description",
    "disabled": "Désactivé",
    "discount": "Rabais",
    "displayType": "Mode d'affichage",
    "duration": "Durée",
    "email": "Adresse e-mail",
    "emailDefaultLanguage": "Langue par défaut",
    "emailReminderOffset": "Préavis des rappels e-mail",
    "emailReminderSwitchOff": "Activer les rappels e-mail",
    "emailReminderSwitchOn": "Rappels emails activés",
    "employee": "Employé",
    "enabled": "Activé",
    "end": "Fin",
    "eventDetails": "Evènement privé",
    "favoriteEmployee": "Employé préféré",
    "favoriteEmployeeOnly": "Voir uniquement les disponibilités de {firstName}",
    "firstname": "Prénom",
    "fixedDuration": "Durée fixe",
    "flexible": "Flexible",
    "flexibleTimetable": "Horaire flexible",
    "from": "Début",
    "gender": "Titre",
    "genderOther": "Non spécifié",
    "gift": "Bon cadeau | Bon cadeau | Bons cadeaux",
    "homePhone": "Téléphone fixe privé",
    "lastname": "Nom",
    "location": "Etablissement",
    "logo": "Logo de l'entreprise",
    "machineModel": "Modèle",
    "maxEnd": "Fin de journée possible jusqu'à",
    "median": "Médiane",
    "method": "Mode",
    "minStart": "Début de journée possible dès",
    "mobilePhone": "Natel privé",
    "mobileProPhone": "Natel professionnel",
    "more": "Plus",
    "mr": "Monsieur",
    "mrs": "Madame",
    "name": "Nom",
    "newPrice": "Nouveau prix",
    "no": "Non",
    "noImagesAvailable": "Aucune image disponible",
    "notFlexibleTimetable": "Horaire fixe",
    "number": "Numéro",
    "numberOfVisitForVoucher": "Nombre de réservations payées",
    "ownCategory": "Je serai avec",
    "password": "Mot de passe",
    "paymentMethod": "Méthode de paiement",
    "picture": "Photos de l'entreprise",
    "planning": "Planning",
    "pointsPerChfConversion": "Rapport de fidélité",
    "possibleCategories": "J’ai potentiellement besoin de",
    "postcard": "Postcard",
    "preference": "Préférences",
    "price": "Prix",
    "privateComment": "Note privée",
    "publicName": "Nom public",
    "quantity": "Quantité",
    "reason": "Motif",
    "region": "Région",
    "role": "Rôle",
    "service": "Prestation",
    "serviceNameOrNumber": "Nom ou numéro de prestation",
    "servicePart": {
      "duration": "Durée",
      "start": "Minutes depuis le début"
    },
    "shortName": "Nom court",
    "smsReminderOffset": "Préavis des rappels sms",
    "smsReminderSwitchOff": "Activer les rappels sms",
    "smsReminderSwitchOn": "Rappels sms activés",
    "special": "Spécial",
    "standardDuration": "Durée standard",
    "start": "Début",
    "startOfDay": "Début de la journée",
    "step": "Étape",
    "subtotal": "Sous-total",
    "summary": "Motif",
    "time": "Heure",
    "timetablesEnabled": "Horaires",
    "total": "Total",
    "totalTimeSlot": "Remplir tout le créneau horaire",
    "uidNumber": "Numéro UID",
    "unavailable": "En congé",
    "uniqueIdentifier": "Identifiant unique",
    "unitPrice": "Prix unitaire",
    "until": "À",
    "username": "Nom d'utilisateur",
    "uuid": "Identifiant unique",
    "valid": "Valable",
    "validFrom": "Valable dès le",
    "validUntil": "Valable jusqu'au",
    "validity": "Validité",
    "value": "Valeur",
    "verified": "Vérifié",
    "week": "Semaine",
    "wording": "Libellé",
    "workPhone": "Téléphone professionnel",
    "yes": "Oui",
    "zip": "NPA",
    "zoom": "Zoom",
    "": ""
  },
  "location": {
    "color": "Couleur",
    "nameHint": "Utilisation interne uniquement.",
    "shortNameHint": "Max 5 caractères (utilisation interne uniquement)."
  },
  "locationForm": {
    "workplaces": {
      "label": "Espaces de travail"
    }
  },
  "locations": {
    "addInformation": "Un établissement est une des adresse où vous fournissez vos prestations.",
    "address": "Adresse",
    "afterClosedFromNotice": "Cet établissement est fermé. Si vous souhaitez le réouvrir, cliquer sur le lien ci-dessous. Si vous souhaitez le supprimer, veuillez cliquer sur le bouton en haut à droite.",
    "afterClosedFromNoticeTitle": "Etablissement fermé depuis le {date}",
    "beforeClosedFromNotice": "Cet établissement est fermé. Si vous souhaitez le réouvrir, cliquer sur le lien ci-dessous. Si vous souhaitez le supprimer, veuillez attendre que la date de fermeture soit passée.",
    "beforeClosedFromNoticeTitle": "Etablissement fermé dès le {date}",
    "city": "Localité",
    "closeFrom": "Fermer",
    "closed": "Fermé",
    "closedDates": {
      "addClosedDate": "Ajouter un jour de fermeture",
      "closedFrom": "Fermez temporairement ou définitivement l'établissement depuis une date donnée. Vous pourrez supprimer l'établissement qu'une fois la date de fermeture passée.",
      "date": "Date",
      "day": "Jour",
      "description": "Renseignez ici les jours fériés ou d’autres dates où cet établissement est fermé, cela empêchera toute prise de rendez-vous.",
      "reason": "Raison"
    },
    "closedFrom": "Planifier la fermeture",
    "closedFromAlert": "Cet établissement est fermé depuis le {0}.",
    "closedFromAlertReOpen": "Cliquez ici pour le ouvrir à nouveau cet établissement.",
    "name": "Nom",
    "noRegion": "Sans région",
    "open": "Ouvert",
    "reopen": "Rouvrir",
    "zip": "NPA"
  },
  "login": {
    "connectedAs": "Vous êtes connecté en tant que : ",
    "createAccount": "Créez un compte",
    "forgotPassword": "Vous avez oublié votre mot de passe ?",
    "hasAccount": "J'ai un compte",
    "noAccount": "Vous n'avez pas de compte ?",
    "title": "Connexion",
    "username": "Nom d'utilisateur",
    "usernameOrEmail": "Nom d'utilisateur ou adresse e-mail"
  },
  "machines": {
    "addModel": "Ajouter un modèle de ressource",
    "addRessource": "Ajouter une ressource",
    "associatedService": "Prestations utilisant cette ressource",
    "editModel": "Editer un modèle de ressource",
    "emptyDataset": "Aucune ressource matérielle",
    "modelMisconfigured": "Vous devez associer ce modèle a une prestation au minimum.",
    "search": {
      "placeholder": "Nom de la ressource"
    }
  },
  "monthlyStats": {
    "bookingStatus": "Statut des réservations",
    "canceled": "Annulées",
    "confirmed": "Confirmées",
    "customerTypes": "Types de clients",
    "enableComparison": "Activer la comparaison",
    "executed": "Effectuées",
    "female": "Femmes",
    "genderDistribution": "Répartition par genre",
    "male": "Hommes",
    "month": "Mois",
    "newCustomers": "Nouveaux clients",
    "noShow": "Non venu",
    "open": "Ouvertes",
    "other": "Autre",
    "period1": "Période 1",
    "period2": "Période 2",
    "recurringCustomers": "Clients récurrents",
    "totalBookings": "Total des réservations",
    "totalCustomers": "Total des clients",
    "totalUniqueCustomers": "Total des clients uniques",
    "year": "Année"
  },
  "stats": {
    "allEmployees": "Tous les employés",
    "allServices": "Toutes les prestations",
    "annual": "Annuelle",
    "bookingsCount": "Réservations",
    "bookingStatus": "Statut des réservations",
    "canceled": "Annulées",
    "confirmed": "Confirmées",
    "customersCount": "Clients",
    "customerTypes": "Types de clients",
    "employee": "Employé",
    "employeeActivity": "Activité des employés",
    "employeeServices": "Prestations effectuées",
    "enableComparison": "Activer la comparaison",
    "eventsCount": "Prestations",
    "executed": "Effectuées",
    "female": "Femmes",
    "formerEmployee": "ancien employé",
    "genderDistribution": "Répartition par genre",
    "leastUsedServices": "Prestations les moins utilisées",
    "male": "Hommes",
    "month": "Mois",
    "monthly": "Mensuelle",
    "mostUsedServices": "Prestations les plus utilisées",
    "neverUsedServices": "Prestations jamais utilisées",
    "newCustomers": "Nouveaux clients",
    "noComparisonData": "Aucune donnée de comparaison disponible",
    "noDecliningServices": "Aucune prestation en régression",
    "noEmployeeActivity": "Aucune activité",
    "noGrowingServices": "Aucune prestation en croissance",
    "noServicesUsed": "Aucune prestation",
    "noShow": "Non venu",
    "open": "Ouvertes",
    "other": "Autre",
    "period1": "Période 1",
    "period2": "Période 2",
    "periodType": "Type de période",
    "recurringCustomers": "Clients récurrents",
    "resetToNow": "Réinitialiser",
    "serviceName": "Prestation",
    "serviceNumber": "N°",
    "serviceUsage": "Utilisation des prestations",
    "showAllServices": "Toutes les prestations",
    "topDecliningServices": "Prestations en forte régression (>50 utilisations)",
    "topGrowingServices": "Prestations en forte croissance (>50 utilisations)",
    "totalBookings": "Total des réservations",
    "totalCustomers": "Total des clients",
    "totalUniqueCustomers": "Total des clients uniques",
    "unnamedService": "Prestation sans article",
    "usageCount": "Utilisation",
    "workedHours": "Heures",
    "year": "Année"
  },
  "multiselect": {
    "listEmpty": "Il n'y a pas d'autres éléments disponibles",
    "maxElements": "Vous ne pouvez pas sélectionner plus d'éléments. Veuillez d'abord supprimer une option sélectionnée pour en sélectionner une autre.",
    "select": "Sélectionner"
  },
  "myAccount": {
    "EmailLink": "Obtenir mon lien de validation",
    "EmailValidationExplanation": "En validant votre e-mail vous pourrez récupérer vos comptes clients créé par vos prestataires, être sûr de pouvoir récupérer votre mot de passe et recevoir les notifications de vos rendez-vous.",
    "EmailValidationHow": "Pour valider votre e-mail, consulter votre boîte de réception et cliquez sur le lien dans l'e-mail que nous vous avons envoyé.",
    "EmailValidationLink": "Pour recevoir à nouveau un lien de validation pour votre e-mail, cliquer sur ce lien :",
    "EmailValidationTitle": "Valider mon email",
    "NoVendor": "Pas de prestataires actifs",
    "account": "Mon compte client chez",
    "contactUs": "Contactez-nous par e-mail à <a href=\"mailto:harmony{'@'}jmservices.ch\">harmony{'@'}jmservices.ch</a> ou par téléphone au <a href=\"tel:+41582426400\">058 242 64 00</a> pour vos prochains rendez-vous.",
    "information": "Informations importantes",
    "loadingError": "Une erreur est survenue lors du chargement du compte client.",
    "makeAppointment": "Prendre un rendez-vous",
    "makeAppointmentByEmail": "Par e-mail",
    "makeAppointmentByPhone": "Par téléphone",
    "makeFirstAppointment": "Prendre mon premier rendez-vous",
    "tabs": {
      "myInfo": "Mes informations"
    },
    "sections": {
      "upcoming": "À venir",
      "history": "Historique",
      "invoices": "Factures",
      "vouchers": "Fidélité"
    }
  },
  "myAccountEdit": {
    "success": "Votre compte a été modifié avec succès",
    "title": "Mes coordonnées"
  },
  "name": {
    "article": "Article | Article | Articles",
    "association": "Association | Associations",
    "day": "Jour",
    "fidelityVoucher": "Bon de fidélité | Bon de fidélité | Bons de fidélité",
    "payment": "Paiement | Paiement | Paiements",
    "planning": "Planning",
    "service": "Prestation | Prestation | Prestations",
    "slug": "Slug",
    "voucher": "Bon cadeau | Bon cadeau | Bons Cadeaux",
    "week": "Semaine"
  },
  "navbar": {
    "about": "A propos",
    "admin": "Espace entreprise",
    "becomeVendor": "Inscrire mon entreprise",
    "bookNow": "Réserver maintenant",
    "features": "Fonctionnalités",
    "industries": "Industries",
    "language": "Langue",
    "login": "Connexion",
    "logout": "Déconnexion",
    "myAccount": "Mon compte",
    "myAccountEdit": "Mes coordonnées",
    "settings": "Réglages"
  },
  "onboarding": {
    "addLocationHelpText": "Bienvenue sur Weeezy !\nVous devez configurer votre compte, nous allons vous guider, suivez le point violet dans le menu de gauche !\nTout d'abord, créons votre premier établissement.",
    "addServiceHelpText": "Bravo, votre premier établissement a été créé !\nVous devez maintenant ajouter vos prestations.",
    "addTimetableHelpText": "Vous y êtes presque !\nPour finir, vous devez créer votre horaire.",
    "completeModalText1": "Vous avez terminé la configuration de base de votre compte entreprise.",
    "completeModalText2": "Vous pouvez continuer à configurer votre compte en ajoutant des employés, des prestations, les clients existants et découvrir les autres fonctionnalités de Weeezy.",
    "completeModalTitle": "Bravo !",
    "helpText": "Votre compte n'est pas encore actif ou visible par le public. Vous devez d'abord finir la configuration.",
    "liveModeButton": "Activer mon compte",
    "liveModeHelpText": "Si vous avez fini de configurer de votre compte, vous pouvez activer définitivement votre compte.",
    "liveModeTitle": "Tout est prêt ?",
    "setupTitle": "Préparation de votre compte",
    "toLocations": "Vers les établissements",
    "toServices": "Vers les prestations",
    "toTimetables": "Vers les horaires"
  },
  "openBookings": {
    "none": "Aucun rendez-vous prévu",
    "title": "Prochain rendez-vous | Prochains rendez-vous"
  },
  "pagination": {
    "total": "Total :"
  },
  "passwordInput": {
    "forgotPassword": "Vous avez oublié votre mot de passe ?",
    "hint": "Le mot de passe doit faire au minimum 6 caractères",
    "label": "Mot de passe"
  },
  "placeholder": {
    "addDescription": "Ajouter une description",
    "addPrice": "Ajouter le prix",
    "addQuantity": "Ajouter la quantité",
    "customer": "Nom ou prénom du client",
    "employee": "Nom ou prénom de l'employé",
    "location": "Nom de l'établissement",
    "region": "Nom de la région",
    "searchServices": "Nom ou n° de prestation",
    "selectDate": "Sélectionnez la date",
    "service": "Nom ou numéro de la prestation",
    "voucherCode": "Code bon cadeau"
  },
  "privateEvent": {
    "addTitle": "Ajouter un évènement privé",
    "editTitle": "Editer un évènement privé",
    "summary": "Titre"
  },
  "regions": {
    "addRegion": "Nouvelle région",
    "editRegion": "Modifier région"
  },
  "reports": {
    "difference": "Non sélectionné",
    "download": {
      "csv": "Télécharger CSV",
      "excel": "Télécharger Excel"
    },
    "selected": "Sélectionné",
    "stats": "Statistiques",
    "total": "Total des paiements"
  },
  "resetPassword": {
    "title": "Nouveau mot de passe"
  },
  "resetPasswordConfirmation": {
    "description": "Merci de vous rendre dans votre boîte de réception et de suivre les instructions dans l’e-mail que nous avons envoyé afin de réinitialiser votre mot de passe.",
    "title": "Un e-mail vous a été envoyé à"
  },
  "resource": {
    "added": "Nouvel élément ajouté : {0}",
    "deleted": "Élément supprimé",
    "edited": "Les données ont été enregistrées."
  },
  "schedule": {
    "dateException": "Horaire exceptionnel",
    "notPlanned": "Non planifié"
  },
  "selectInput": {
    "emptyLabel": "Veuillez sélectionner"
  },
  "serviceForm": {
    "advanced": {
      "helpText": "Certaines prestations ne nécessite pas votre présence permanente. Ici vous pouvez définir à quelle moment vous devez vous occuper de votre client.",
      "parts": {
        "add": "Ajouter attentions au client",
        "addInter": "Ajouter un moment intermédiaire",
        "delete": "Supprimer toutes les moments avec client",
        "removeInter": "Supprimer ce moment intermédiaire",
        "title": "Moments avec le client"
      },
      "title": "Paramètres avancés"
    },
    "associatedServices": {
      "helpText": "Lors du choix de cette prestation par les clients, les prestations suivantes seront mise en avant.",
      "label": "Prestations associées"
    },
    "basics": {
      "title": "Données de base"
    },
    "duration": {
      "currentBookingsWillBeKept": "La durée modifiée ne sera utilisée que pour les nouvelles réservations.",
      "title": "Durée"
    },
    "machines": {
      "label": "Ressources matérielles"
    },
    "notPreferredEmployees": {
      "currentBookingsWillBeKept": "Si des RDV ont été pris avec cet employé, ils seront gardés.",
      "label": "Employés habilités non prioritaires",
      "labelTooltip": "Lors de la prise de RDV, un employé NON PRIORITAIRE sera proposé uniquement si aucun employé prioritaire n'est disponible."
    },
    "preferredEmployees": {
      "currentBookingsWillBeKept": "Si des RDV ont été pris avec cet employé, ils seront gardés.",
      "label": "Employés habilités prioritaires",
      "labelTooltip": "Lors de la prise de RDV, un employé PRIORITAIRE sera toujours proposé pour effectuer ce soin s'il est disponible."
    },
    "priceCantBeModified": "Le prix ne pourra plus être modifié après l'enregistrement.",
    "prices": {
      "title": "Prix actuels et futurs"
    },
    "workplaces": {
      "label": "Espaces de travail"
    }
  },
  "services": {
    "addInformation": "Les clients pourront réserver une ou plusieurs prestations.",
    "childServicesModal": {
      "title": "Soins complémentaires"
    },
    "selectServices": "Sélectionner une prestation | Sélectionner des prestations",
    "sortServicePerformedOrder": "Ordre d'exécution",
    "sortServicePerformedOrderComment": "Les prestations seront ordonnées dans les réservations dans l'ordre ci-dessous. Une prestation en-dessus d'une autre est considérée comme devant être effectuée avant celle d'en-dessous. L'ordre est particulièrement important si une réservation est répartie sur plusieurs employés."
  },
  "settings": {
    "integrations": {
      "addApp": "Ajouter l'app Weeezy à votre espace de travail Slack  :",
      "appAdded": "Vous avez intégré Slack et recevez les notifications dans votre équipe <b>{team}</b> sur le canal <b>{channel}</b>.",
      "slackMessage": "Recevez vos notifications de rendez-vous sur Slack"
    },
    "limit": {
      "alert": "La limitation journalière n'est pas respectée quand vous ajoutez manuellement un RDV depuis le calendrier.",
      "title": "Limites journalière de prestations",
      "perDay": "x / jour"
    },
    "maxServicesPerDay": "La limitation n'est pas respectée quand vous ajoutez manuellement un RDV depuis le calendrier.",
    "navbar": {
      "fidelity": "Fidélité",
      "general": "Entreprise",
      "images": "Images",
      "integrations": "Intégrations",
      "loyalty": "Fidélité",
      "public": "Annuaire",
      "settings": "Réservations"
    },
    "visibility": {
      "limit": "Ouvrir la réservation en ligne pour les prochains",
      "title": "Limiter la prise de rendez-vous par les clients"
    }
  },
  "sidebar": {
    "calendar": "Agenda",
    "cashClosing": "Clôture de caisse",
    "closedDates": "Jour de fermeture",
    "config": "Configuration",
    "customers": "Clients",
    "employees": "Employés",
    "giftCards": "Bons cadeaux",
    "locations": "Etablissements",
    "monthlyStats": "Statistiques mensuelles",
    "myVendor": "Mon entreprise",
    "planning": "Planification",
    "regions": "Régions",
    "reports": "Rapports",
    "resources": "Ressource matérielle | Ressources matérielles",
    "schedules": "Horaires",
    "services": "Prestations",
    "sharedResources": "Ressource matérielle | Ressources matérielles",
    "stats": "Statistiques",
    "vendorBookings": "Réservations",
    "workplaces": "Espace de travail | Espaces de travail"
  },
  "signUp": {
    "title": "Créer votre compte",
    "usernameHint": "Il est également possible d’utiliser un nom d’utilisateur pour se connecter."
  },
  "signUpConfirmation": {
    "description": "Merci de vous rendre dans votre boîte de réception et de suivre les instructions dans l’e-mail que nous avons envoyé afin de valider la création de votre compte.",
    "title": "Un lien d’activation vous a été envoyé à"
  },
  "timetable": {
    "add": "Ajouter un horaire",
    "block": "Bloc",
    "break": "Pause",
    "capacityThreshold": "Un premier bloc doit être rempli à {threshold}% pour que le suivant s'ouvre.",
    "dateException": "Horaire exceptionnel",
    "duplicate": "Dupliquer un horaire",
    "edit": "Modifier un horaire",
    "editInfo": {
      "validFromIsToday": "En modifiant cet horaire, nous allons créer un nouvel horaire valable dès aujourd'hui."
    },
    "from": "dès",
    "max_end": "Fin possible jusqu'à",
    "min_start": "Début possible dès",
    "until": "jusqu'à",
    "willOverride": "Vous avez déjà un horaire planifié dès le {validFrom}. En enregistrant les données, vous allez remplacer cet horaire."
  },
  "timetableExceptions": {
    "add": "Ajouter un horaire exceptionnel",
    "duplicate": "Dupliquer un horaire exceptionnel",
    "edit": "Modifier un horaire exceptionnel",
    "empty": {
      "future": "Aucun horaire exceptionnel à venir",
      "past": "Aucun horaire exceptionnel"
    },
    "future": "Futur",
    "info": {
      "replace": "Vous avez déjà un horaire exceptionnel planifié le {date}. En enregistrant les données, vous allez remplacer cet horaire exceptionnel."
    },
    "name": "Horaire exceptionnel",
    "onThe": "du",
    "past": "Actuel et Passé",
    "title": "Exceptionnel"
  },
  "timetables": {
    "actual": "Horaire actuel",
    "available": "Disponible",
    "block": "Bloc de travail",
    "dateException": "Horaire exceptionnel",
    "empty": {
      "employees": "Aucun employé n'a ses horaires activés. Activez-les dans la fiche de l'employé, depuis Employés.",
      "future": "Aucun horaire récurrent à venir",
      "past": "Aucun horaire récurrent"
    },
    "from": "Dès le :",
    "fromThe": "dès le",
    "future": "A venir",
    "mayUse": "Peut utiliser",
    "name": "Horaire récurent",
    "notAvailable": "En congé",
    "past": "Actuel et Passé",
    "repeatForTheFollowingDays": "Répéter pour les jours suivants",
    "title": "Récurrent",
    "total": "Nombre d'heures planifiées :",
    "unknownLocation": "Inconnu",
    "with": "Avec"
  },
  "toast": {
    "changesSaved": "Données enregistrées.",
    "changesSavingError": "Erreur lors de l'enregistrement des données. Toutes les modifications n'ont pas pu être sauvegardées.",
    "closedDateDeleted": "Date de fermeture supprimée",
    "copiedToClipboard": "Le lien a été copié dans votre presse-papiers.",
    "customerDeleted": "Le client a été supprimé",
    "employeeDeleted": "Employé a été supprimé",
    "eventDeleted": "Événement supprimé.",
    "liveModeEnabled": "Votre compte a été activé ! Vous êtes désormais visible dans l'annuaire de nos prestataires.",
    "locationDeleted": "Etablissement supprimé",
    "machineDeleted": "Ressource matérielle supprimée",
    "regionDeleted": "Région supprimée",
    "serviceDeleted": "Prestation supprimée.",
    "timetableExceptionAdded": "Horaire exceptionnel ajouté",
    "timetableExceptionModified": "Horaire exceptionnel modifié",
    "validationErrors": "Il y des erreurs dans le formulaire",
    "workplaceDeleted": "Espace de travail supprimé."
  },
  "validation": {
    "afterTime": "L'heure doit être postérieure à {time}",
    "alphaNumeric": "Doit être alphanumérique",
    "decimal": "La valeur doit être un montant",
    "uniqueDate": "Cette date est déjà prise",
    "divider": "Le nombre doit être un multiple de {value}",
    "double": "La valeur doit être un nombre avec 2 décimales",
    "excluded": "La valeur doit être différente de {excluded}",
    "formHasErrors": "Le formulaire contient des erreurs",
    "greaterThan": "La valeur doit être plus grande que {value}",
    "invalidEmail": "E-mail non valide",
    "invalidPhone": "Téléphone non valide, utiliser le format international",
    "invalidTime": "Heure non valide",
    "length": "Longueur requise {length}",
    "maximumLength": "Longueur maximale {max}",
    "maximumValue": "Valeur maximale {max}",
    "minimumLength": "Longueur minimale {min}",
    "minimumValue": "Valeur minimale {min}",
    "numeric": "La valeur doit être un entier",
    "otherField": "Ce champ et le champ \"{value}\" doivent être vides ou remplis les deux.",
    "required": "Obligatoire",
    "startMustBeBeforeEnd": "L'heure de début doit être antérieure à l'heure de fin",
    "valueAlreadyRegistered": "{value} est déjà enregistré",
    "weakPin": "PIN trop simple : évitez les suites et les chiffres répétés."
  },
  "vendorBookings": {
    "allEmployees": "Tous les employés",
    "allStatuses": "Tous les statuts",
    "none": "Aucune réservation",
    "presets": {
      "lastMonth": "Mois dernier",
      "nextMonth": "Mois prochain",
      "nextQuarter": "Trimestre prochain",
      "thisMonth": "Ce mois",
      "thisQuarter": "Ce trimestre"
    },
    "title": "Réservations",
    "withDeparted": "Inclure les employés partis"
  },
  "vendorSignUp": {
    "generalSettings": {
      "bookingSettingsInformation": "En ajustant les paramètres, vous modifier le nombre de propositions de rendez-vous de l'outil de réservation.",
      "employee": "Employé",
      "fidelity": "Réglage des bons de fidélité",
      "fidelityInformation": "Les bons de fidélité récompense les clients pour les réservations effectuées et payées. Après un certain nombre de réservations que vous pouvez définir, le client reçoit un bon de fidélité. La valeur de ce bon dépend du total dépensé sur vos prestations divisé par le rapport de fidélité.",
      "location": "Etablissement",
      "minutes": "Minutes",
      "remainingCredits": "Il vous reste {n} crédit sms | Il vous reste {n} crédits sms",
      "remainingCreditsZero": "Vous n'avez pas de crédit sms. Aucun sms ne sera envoyé !",
      "reminderTitle": "Rappels des réservations",
      "remindersInformation": "Choisissez ici si vous souhaitez envoyer des sms ou des e-mails de rappel avant les rendez-vous et le préavis de ces rappels.",
      "resources": "Ressources",
      "service": "Prestation",
      "slack": "Intégration Slack",
      "title": "Paramètres généraux",
      "userAccount": "Compte utilisateur",
      "userAccountInfo": "Créez un compte utilisateur pour vous connecter à Weeezy. Vous pourrez ainsi gérer votre compte entreprise.",
      "workingSchedule": "Horaire de travail"
    },
    "legalInfo": {
      "title": "Données entreprise"
    },
    "legalInformation": {
      "information": "Les informations de votre entreprise ne sont pas publiées sur les pages publiques de Weeezy. Ces informations nous permettent de vous contacter, vous envoyer des documents et vérifier que vous existez."
    },
    "publicInfo": {
      "galleryDragDrop": "Glissez-déposez vos images ou <span class=\"filepond--label-action\">Parcourir</span>",
      "galleryHelp": "Téléchargez des photos de votre entreprise qui seront affichées sur votre page publique.",
      "galleryHelpText": "Formats acceptés: JPG, PNG. Taille maximum: 5MB par fichier. Maximum 10 fichiers.",
      "galleryLabel": "Photos de l'entreprise",
      "logoDragDrop": "Glissez-déposez votre logo ou <span class=\"filepond--label-action\">Parcourir</span>",
      "logoHelp": "Téléchargez le logo de votre entreprise qui sera affiché sur votre page publique.",
      "logoHelpSvg": "Préférez un logo au format SVG.",
      "logoHelpText": "Formats acceptés: JPG, PNG, WebP, SVG. Taille maximum: 3MB. Un seul fichier.",
      "logoHelpWhiteBg": "Si vous téléchargez un logo avec des bordures blanches, celles-ci seront automatiquement supprimées.",
      "logoLabel": "Logo de l'entreprise",
      "pictureViaEmail": "Transmettez-nous vos photos au format JPG ou PNG (800px x 1200px) et votre logo au format au format PDF / SVG ou PNG (800px x 1200px) par e-mail à l'adresse",
      "title": "Données publiques"
    },
    "publicInformation": {
      "information": "Ces informations seront utilisées sur l'annuaire de Weeezy. Veillez à fournir des informations exactes pour faciliter la recherche."
    },
    "title": "Devenir un prestataire"
  },
  "voucher": {
    "addTitle": "Ajouter un bon cadeau",
    "balance": "Solde",
    "confirmDelete": "Veuillez confirmer la suppression du bon cadeau ayant pour référence {uuid} à l'aide du bouton \"Supprimer\" ci-dessous",
    "deletionConfirmed": "Le bon cadeau a été supprimé",
    "notValidSince": "Plus valable depuis le",
    "onlyLetters": "Lettres uniquement",
    "report": "A reporter sur le bon",
    "uuidText": "Voici l'identifiant unique à noter sur le bon physique :",
    "validUntil": "Valable jusqu'au"
  },
  "word": {
    "booking": "Réservation",
    "free": "Libre",
    "invoice": "Facture|Factures",
    "line": "Ligne"
  },
  "workplaceForm": {
    "authorizedServices": {
      "label": "Prestations autorisées",
      "labelTooltip": "Lors de la prise de RDV, ces prestations seront proposées en complément au client."
    },
    "color": "Couleur du calendrier (RGB)",
    "notPreferredEmployees": {
      "label": "Employés habilités non prioritaires",
      "labelTooltip": "Lors de la prise de RDV, un employé NON PRIORITAIRE sera proposé uniquement si aucun employé prioritaire n'est disponible."
    },
    "preferredEmployees": {
      "label": "Employés habilités prioritaires",
      "labelTooltip": "Lors de la prise de RDV, un employé PRIORITAIRE sera toujours proposé pour effectuer ce soin s'il est disponible."
    }
  },
  "employeeMembership": {
    "accessRemoved": "L'employé n'a plus accès à l'admin.",
    "accessUntilDeparture": "L'employé garde l'accès à l'admin jusqu'au {date} à 23h.",
    "cancelDeparture": "Annuler le départ",
    "cancelDepartureConfirm": "Annuler le départ de {name} ?",
    "deleteConfirm": "Supprimer définitivement {name} ?",
    "departureCancelled": "Départ annulé",
    "departureIntro": "Choisissez le dernier jour de travail de {name}. Son accès à l'admin reste ouvert jusqu'à ce jour-là, 23h.",
    "departureRecorded": "Départ enregistré",
    "departureRequirements": {
      "title": "Avant d'enregistrer le départ, vous devez, après son dernier jour :",
      "timetable": "vider son horaire",
      "appointments": "déplacer ses rendez-vous",
      "openings": "retirer ses ouvertures exceptionnelles"
    },
    "departureTitle": "Départ de {name}",
    "invitationSent": "Invitation envoyée à {email}",
    "invite": "Inviter",
    "inviteHelp": "Un lien valable 7 jours est envoyé à cette adresse pour créer un compte ou lier un compte existant. Un nouvel envoi remplace le précédent.",
    "inviteTitle": "Inviter {name}",
    "lastDay": "Dernier jour travaillé",
    "leavingOn": "Dernier jour le {date}",
    "leftOn": "Départ le {date}",
    "noAccount": "Sans compte",
    "recordDeparture": "Enregistrer le départ",
    "showDeparted": "Voir les départs"
  },
  "spaces": {
    "title": "Choisir un espace",
    "help": "Votre compte donne accès à plusieurs espaces. Choisissez celui dans lequel vous voulez travailler.",
    "customer": "Mon compte client",
    "switch": "Changer d'espace",
    "roles": {
      "2": "Staff",
      "3": "Admin"
    }
  },
  "invitation": {
    "title": "Invitation",
    "message": "{vendor} vous invite à rejoindre son équipe en tant que {name}.",
    "invalid": "Cette invitation a expiré ou a déjà été utilisée. Demandez-en une nouvelle à votre employeur.",
    "signInFirst": "Connectez-vous avec votre compte, ou créez-en un, pour accepter l'invitation.",
    "accept": "Accepter l'invitation"
  },
  "notFound": {
    "text": "Cette adresse ne correspond à aucune page. Vérifiez-la ou passez par le menu.",
    "title": "Page introuvable",
    "publicText": "L'adresse est peut-être mal tapée, ou le lien a changé. Passez par le menu."
  }
}
